import React from 'react';
import PropTypes from 'prop-types';
import DropdownA from 'components/Dropdown/DropdownA';
import Link from 'components/Link/Link';
import classes from './NavDropdown.module.scss';

const NavDropdown = (props) => {
  const {
    searchPlaceholderText, nodes,
  } = props;

  const listDisplay = (item) => (
    <Link href={item.url} title={item.title} className={classes.optionWrapper}>
      <span className={classes.dropdownTitle} dangerouslySetInnerHTML={{ __html: item.title }} />
    </Link>
  );

  const singleValue = (item) => (
    <span className={classes.singleValueWrapper}>
      <span className={classes.dropdownTitle} dangerouslySetInnerHTML={{ __html: item.title }} />
    </span>
  );

  const newNodes = nodes.map((node) => ({
    ...node,
    renderSingleValue: singleValue(node),
    renderOption: listDisplay(node),
    label: node.title,
  }));

  function open(node) {
    if (node && node.url) {
      window.open(node.url, node.linkTarget);
    }
  }

  function onChange(e) {
    open(e);
  }

  return (
    <div className={classes.wrapper}>
      {/*
        HACK - react-select does not render the list of nav links until the menu is dropped down/opened
        This causes an SEO issue where search engines can not crawl the links
      */}
      <div className={classes.hidden} aria-hidden>
        {nodes.map((node, i) => (
          <Link href={node.url} title={node.title} key={`nav-link-${i}`}>
            <span dangerouslySetInnerHTML={{ __html: node.title }} />
          </Link>
        ))}
      </div>
      {/* HACK - end */}
      <div className={classes.dropdown}>
        <DropdownA
          type='NavDropdown'
          placeholder={searchPlaceholderText}
          onChange={onChange}
          options={newNodes}
          renderOption='renderOption'
          renderSingleValue='renderSingleValue'
          isSearchable
          isClearable
        />
      </div>
    </div>
  );
};

NavDropdown.propTypes = {
  searchPlaceholderText: PropTypes.string,
  nodes: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    linkTarget: PropTypes.string,
    title: PropTypes.string,
  })),
};

export default NavDropdown;
